import styled from "styled-components";
import colors from "../../shared/constants/color";
import { Box, MenuItem, TextField } from "@mui/material";

export const StyledHeader = styled(Box).attrs({
  className: "wiser-header",
}) <{ sidebarOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 64px;
  background-color: ${colors.deepBlue};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 1100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  transition:
    left 0.3s ease-in-out,
    width 0.3s ease-in-out,
    background-color 0.2s ease,
    border-color 0.2s ease;

  [data-theme="dark"] & {
    background-color: var(--w-header-bg);
    border-bottom: 1px solid var(--w-border);
    backdrop-filter: blur(10px);
    box-shadow: var(--w-surface-shadow);
  }

  @media (max-width: 600px) {
    padding: 0 5px;
  }
`;

export const StyledLogo = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StyledNavbarWrap = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: start;
`;

export const StyleNavbarRight = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StyledNavbarElement = styled(Box)<{ ml?: number }>`
  margin-left: ${({ ml }) => ml || 0}px;
`;

export const StyledSearchBox = styled(Box)`
  position: relative;
  width: 360px;
  height: 40px;
  background-color: ${colors.deepBlue};
  margin-left: -24px;
  border-radius: 4px;
  overflow: visible;

  [data-theme="dark"] & {
    background-color: transparent;
  }

  @media (max-width: 600px) {
    width: 30vw;
    min-width: 0;
    max-width: 30vw;
    margin-left: 8px;
  }
`;

export const StyledVerticalDivider = styled(Box)`
  width: 1px;
  height: 24px;
  background-color: #e0e0e0;
  margin: 0 16px;
`;

export const NAV_ELEMENT_MARGINS = {
  default: 3,
  notification: 0,
};

export const StyledSearchResultItem = styled(MenuItem)`
  padding: 8px 16px;
  &:hover {
    background-color: #f5f5f5;
  }

  [data-theme="dark"] & {
    color: var(--w-text-main);
    &:hover {
      background-color: var(--w-table-hover-bg);
    }
  }
`;

export const StyledHeaderActions = styled.div`
  display: flex;
  align-items: center;
  height: 40px;

  & svg {
    color: white;
    font-size: 20px;
  }

  [data-theme="dark"] & svg {
    color: var(--w-text-soft);
  }

  & .dropdown-toggle {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }

  & .MuiIconButton-root {
    padding: 0;
  }
`;

export const StyledHeaderActionSlot = styled.div<{ $alignStart?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $alignStart }) => ($alignStart ? "flex-start" : "center")};
  height: 40px;
  padding: 0 24px;
  flex-shrink: 0;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }

  & img:not([alt="Bildirim Yok"]) {
    display: block;
  }

  [data-theme="dark"] & img:not([alt="Bildirim Yok"]) {
    filter: brightness(0) invert(0.82);
  }

  [data-theme="dark"] & .dropdown-profile img,
  [data-theme="dark"] & .avatar img {
    filter: none;
  }
`;

/** @deprecated use StyledHeaderActions */
export const StyledMessagesWrapper = StyledHeaderActions;

export const StyledIconDivider = styled.div`
  width: 1px;
  height: 40px;
  flex-shrink: 0;
  background-color: ${colors.gray300};
  opacity: 0.25;

  [data-theme="dark"] & {
    background-color: var(--w-border);
    opacity: 1;
  }
`;

export const StyledTextField = styled(TextField)`
  & .MuiInput-underline:before,
  & .MuiInput-underline:after {
    display: none;
    border-bottom: none !important;
  }
  & .MuiInputBase-root:before,
  & .MuiInputBase-root:after {
    display: none;
    border-bottom: none !important;
  }
  height: 40px;
  & .MuiInputBase-root {
    height: 100%;
    border-radius: 4px;
    overflow: visible;
    background-color: ${colors.white};
    padding: 0 56px 0 9px;
    position: relative;
  }
  & .MuiInputBase-input {
    color: ${colors.gray700};
  }
  & .MuiInputBase-input::placeholder {
    color: ${colors.gray1000};
    font-size: 14px;
    weight: 400;
    opacity: 1;
  }
  & .MuiInputAdornment-root {
    margin: 0;
  }

  [data-theme="dark"] & {
    & .MuiInputBase-root {
      background-color: var(--w-input-bg);
      border: 1px solid var(--w-border);
      box-sizing: border-box;
    }
    & .MuiInputBase-input {
      color: var(--w-text-main);
    }
    & .MuiInputBase-input::placeholder {
      color: var(--w-text-muted);
      opacity: 1;
    }
  }
`;

export const StyledSearchAdornment = styled("div")`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 48px;
  background-color: ${colors.blue.B600};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  pointer-events: none;
  border-radius: 0 4px 4px 0;

  [data-theme="dark"] & {
    background-color: var(--w-accent-navy);
    border-left: 1px solid var(--w-border);
  }
`;

export const StyledSearchResults = styled("div")`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
  z-index: 10000;
  margin-top: 0;
  min-height: 40px;

  [data-theme="dark"] & {
    background: var(--w-bg-panel-strong);
    border-color: var(--w-border);
    box-shadow: var(--w-surface-shadow);
  }
`;

export const StyledVersion = styled(Box)`
  display: flex;
  align-items: center;
  margin-right: 16px;
  height: 100%;
`;
